import classNames from 'classnames';
import React from 'react';

export default function Tabs({
  tabsList,
  activeKey,
  setActiveKey,
}: {
  tabsList: {
    label: string;
    key: number;
  }[];
  activeKey: number;
  setActiveKey: (val: number) => void;
}) {
  return (
    <div className='flex w-full justify-evenly rounded-lg border-xs border-background-200 bg-white'>
      {tabsList?.map((item) => (
        <div
          className={classNames(
            'flex h-10 w-full items-center justify-center rounded-md text-center text-14 font-medium hover:cursor-pointer',
            activeKey === item.key
              ? 'bg-primary-default text-white'
              : 'text-text-600'
          )}
          key={item.key}
          onClick={(e) => {
            setActiveKey(item.key);
            // stop event propagation to prevent tooltip from closing
            e.stopPropagation();
          }}
        >
          {item.label}
        </div>
      ))}
    </div>
  );
}
